.flag {
  width: 100%;
  height: 100%;
  color: $active-indicator;
  padding-top: 0.5rem;
  padding-left: 0.75rem;
}
